import API_CONSTANTS from '@/utils/apiConstants';
import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from './customBaseQuery';

const baseUrl = process.env.NEXT_PUBLIC_API_URL.replace(/\/+$/, '');

export const dropdownApi = createApi({
  reducerPath: 'dropdownApi',
  baseQuery: customBaseQuery({ baseUrl }),
  tagTypes: ['Configuration', 'AssociatedFirm'],
  endpoints: (builder) => ({
    getFirms: builder.query({
      query: () => ({
        url: API_CONSTANTS.GET_FIRMS,
        method: 'GET',
      }),
      transformResponse: (response) => response?.data || [],
    }),
    getAssociatedFirm: builder.query({
      query: (brokerId) => ({
        url: `${API_CONSTANTS.GET_ASSOCIATED_FIRM.replace(':brokerId', brokerId)}`,
        method: 'GET',
      }),
      transformResponse: (response) => response?.data || null,
      providesTags: (result, error, brokerId) => [{ type: 'AssociatedFirm', id: brokerId }],
    }),
    getDropdownValues: builder.query({
      query: (categoryType) => ({
        url: `${API_CONSTANTS.GET_DROPDOWN_VALUES.replace(':categoryType', categoryType)}`,
        method: 'GET',
      }),
    }),
    getDependentPropertySubTypes: builder.query({
      query: ({ categoryType, parentCategoryType }) => ({
        url: `/configuration/${categoryType}`,
        params: {
          parentCategoryType,
        },
        method: 'GET',
      }),
      providesTags: (result, error, { categoryType, parentCategoryType }) => [{ type: 'Configuration', id: `${categoryType}-${parentCategoryType}` }],
    }),
  }),
});

export const { useGetDropdownValuesQuery, useGetDependentPropertySubTypesQuery, useGetFirmsQuery, useGetAssociatedFirmQuery } = dropdownApi;
